import { render, staticRenderFns } from "./AssignProductToProvider.vue?vue&type=template&id=9de63e90&"
import script from "./AssignProductToProvider.vue?vue&type=script&lang=js&"
export * from "./AssignProductToProvider.vue?vue&type=script&lang=js&"
import style0 from "./AssignProductToProvider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports